import { render, staticRenderFns } from "./trainingTrainees.vue?vue&type=template&id=4e1dddce"
import script from "./trainingTrainees.vue?vue&type=script&lang=js"
export * from "./trainingTrainees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports